<script lang="ts" setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VMenu from '@shared/component/VMenu/VMenu.vue';
import type { MenuItemCommandEvent } from 'primevue/menuitem';
import { useToggle } from '@vueuse/core';
import { computed, ref } from 'vue';
import { hasPermission } from '@auth/hasPermission';
import { useFeatureToggle } from '@environment/useFeatureToggle';
import { tryMenuNavigation } from '../../urlHelper';
import ServiceDeskModal from '../ServiceDesk/ServiceDeskModal.vue';

const props = withDefaults(
  defineProps<{
    alwaysSmall?: boolean;
    iconStyle?: string;
  }>(),
  { iconStyle: 'far' },
);

const searchUserOpen = defineModel<boolean>('searchUserOpen');
const showTools = hasPermission('Inregeling.InregelingAanpassen');
const nieuwDashboard = useFeatureToggle('NieuwDashboardToggle');

const menu = ref();

const [servicedeskModalOpen, toggleServicedeskModal] = useToggle();

function openTools() {
  window.location.href = '/app/beheerbox/tools/overzicht';
}

const menuItems = computed(() => {
  const items = [
    {
      command: ({ originalEvent }: MenuItemCommandEvent) =>
        tryMenuNavigation(originalEvent, '/content/boaz/werkverdeling'),
      icon: ['far', 'sitemap'],
      label: 'Werkverdeling',
      url: '/content/boaz/werkverdeling',
    },
    {
      command: ({ originalEvent }: MenuItemCommandEvent) =>
        tryMenuNavigation(originalEvent, '/content/agenda'),
      icon: ['far', 'bell'],
      label: 'Agenda',
      url: '/content/agenda',
    },
    {
      command: () => (searchUserOpen.value = !searchUserOpen.value),
      icon: ['far', 'search'],
      label: 'Gebruiker zoeken',
    },
    {
      command: toggleServicedeskModal,
      icon: ['far', 'user-headset'],
      label: 'Servicedesk',
    },
  ];
  return showTools
    ? [
        ...items,
        {
          command: openTools,
          icon: ['far', 'tools'],
          label: 'Tools',
        },
      ]
    : items;
});

function toggleMenu(event: Event) {
  menu.value.toggle(event);
}
</script>

<template>
  <div class="relative flex">
    <button
      title="Intern"
      class="flex cursor-pointer items-center gap-1 border-none bg-transparent px-3 text-sm text-inherit outline-none"
      :class="{
        'lg:px-6': !props.alwaysSmall,
      }"
      type="button"
      @click="toggleMenu"
    >
      <FontAwesomeIcon :icon="[props.iconStyle, 'users']" />
      <span
        v-if="!nieuwDashboard"
        class="hidden"
        :class="{
          'xl:display-unset': !props.alwaysSmall,
        }"
      >
        Intern
      </span>
    </button>

    <VMenu
      append-to="self"
      class="!left-auto !right-0 !top-full"
      :class="{
        'xl:!left-0 xl:!right-auto': !props.alwaysSmall && !nieuwDashboard,
      }"
      :model="menuItems"
      popup
      ref="menu"
    />

    <ServiceDeskModal v-model:is-open="servicedeskModalOpen" />
  </div>
</template>
